import React, { useEffect, useRef, useState } from 'react';
import { Popover } from 'antd';
import { ReactComponent as Selected_Column_Filter_Icon } from '../../../assets/images/svg/Selected_Column_Filter_Icon.svg';
import { ReactComponent as UnSelected_Column_Filter_Icon } from '../../../assets/images/svg/UnSelected_Column_Filter_Icon.svg';
import {
  searchInPatientList,
  setPageIndex,
  setSelectedElapsedTimeRemarks,
  updateDropdownSearchFilter,
} from '../../../store/actions/inPatientAction';
import { useDispatch, useSelector } from 'react-redux';
import {
  CV_DEFAULT_ELAPSED_TIME_DROPDOWN,
  PAV_DEFAULT_ELAPSED_TIME_DROPDOWN,
} from '../../constants/commonConstants';
import { RootState } from '../../../store';
import { isEmpty } from 'lodash';
import '../../../shared/components/tags/inpatienList.less';

export const FilterDropDownRemarks = (): any => {
  const {
    isPreAuthView,
    elapsedTimeDropdown,
    selectedElapsedTimeRemarks,
    isDraftBtnClicked,
  } = useSelector(
    (state: RootState): any => state?.selectedInPatientDetail || {},
  );
  const defaultOptions = isPreAuthView
    ? PAV_DEFAULT_ELAPSED_TIME_DROPDOWN
    : CV_DEFAULT_ELAPSED_TIME_DROPDOWN;
  const [options, setOptions] = useState<string[]>(defaultOptions);
  const dropDownRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect((): void => {
    if (!isEmpty(elapsedTimeDropdown)) {
      setOptions(elapsedTimeDropdown);
    } else {
      setOptions([]);
    }
  }, [elapsedTimeDropdown]);

  const selectOptions = (option: string): void => {
    const updatedSearchFilter = selectedElapsedTimeRemarks?.includes(option)
      ? selectedElapsedTimeRemarks?.filter(
          (compareOption: string): boolean => compareOption !== option,
        )
      : [...selectedElapsedTimeRemarks, option];
    dispatch(setPageIndex(1));
    dispatch(updateDropdownSearchFilter({ elapsedTime: updatedSearchFilter }));
    dispatch(setSelectedElapsedTimeRemarks(updatedSearchFilter));
    dispatch(searchInPatientList());
  };

  const content: JSX.Element = (
    <div className="dropdown-options-container">
      {options?.map(
        (option: string): JSX.Element => (
          <div
            key={option}
            className={`option-pill ${
              selectedElapsedTimeRemarks?.includes(option)
                ? 'option-pill-selected'
                : ''
            }`}
            onClick={(): void => selectOptions(option)}
          >
            {option}
          </div>
        ),
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      overlayClassName="custom-popover"
      trigger={isEmpty(options) || isDraftBtnClicked ? '' : 'click'} // Disable popover if no options or draft button is clicked
      placement="topLeft"
      getPopupContainer={(): HTMLElement =>
        dropDownRef.current || document.body
      }
    >
      <div
        ref={dropDownRef}
        className="d-inline-block px-4"
        role="button"
        tabIndex={0}
      >
        {isEmpty(selectedElapsedTimeRemarks) ? (
          <UnSelected_Column_Filter_Icon
            className={`m--1 transform-none ${
              isEmpty(options) || isDraftBtnClicked
                ? 'mouse-not-allowed'
                : 'mouse-pointer' // for draft case there is no dropdown options
            }`}
          />
        ) : (
          <Selected_Column_Filter_Icon className="transform-none mouse-pointer m--1" />
        )}
      </div>
    </Popover>
  );
};
